//
// Original collection by Kjetil Midtgarden Golid
// https://github.com/kgolid/chromotome
// https://kgolid.github.io/chromotome-site/
//
export default [
  {
    name: 'jung_bird',
    colors: ['#fc3032', '#fed530', '#33c3fb', '#ff7bac', '#fda929'],
    stroke: '#000000',
    background: '#ffffff',
    type: 'jung',
  },
  {
    name: 'jung_horse',
    colors: ['#e72e81', '#f0bf36', '#3056a2'],
    stroke: '#000000',
    background: '#ffffff',
    type: 'jung',
  },
  {
    name: 'jung_croc',
    colors: ['#f13274', '#eed03e', '#405e7f', '#19a198'],
    stroke: '#000000',
    background: '#ffffff',
    type: 'jung',
  },
  {
    name: 'jung_hippo',
    colors: ['#ff7bac', '#ff921e', '#3ea8f5', '#7ac943'],
    stroke: '#000000',
    background: '#ffffff',
    type: 'jung',
  },
  {
    name: 'jung_wolf',
    colors: ['#e51c39', '#f1b844', '#36c4b7', '#666666'],
    stroke: '#000000',
    background: '#ffffff',
    type: 'jung',
  },
];
